import React, { useState, useEffect, useRef } from 'react'
import './JobMatchingFeature.css'

import SignupSlider1 from "../../../../assets/img/signup-images/first.png";
import SignupSlider2 from "../../../../assets/img/signup-images/second.png";
import SignupSlider3 from "../../../../assets/img/signup-images/third.png";
import SignupSlider4 from "../../../../assets/img/signup-images/fourth.png";
import SignupSlider5 from "../../../../assets/img/signup-images/last.png";

const slides = [
  SignupSlider1,
  SignupSlider2,
  SignupSlider3,
  SignupSlider4,
  SignupSlider5,
];

export const JobMatchingFeature = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const timerRef = useRef(null);
  const isMountedRef = useRef(false);

  const scheduleNextSlide = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(() => {
      if (!isMountedRef.current) return;
      setActiveIndex((prev) => (prev + 1) % slides.length);
      scheduleNextSlide();
    }, 3000);
  };

  useEffect(() => {
    isMountedRef.current = true;
    scheduleNextSlide();

    return () => {
      isMountedRef.current = false;
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  return (
    <div className="jm-slider">
      <div
        className="jm-slider-track"
        style={{ transform: `translateX(-${activeIndex * 100}%)` }}
      >
        {slides.map((slide, index) => (
          <img
            key={index}
            src={slide}
            alt={`Slide ${index + 1}`}
            className="jm-slider-image"
          />
        ))}
      </div>

      <div className="jm-slider-nav">
        {slides.map((_, index) => (
          <button
            key={index}
            type="button"
            className={
              'jm-slider-dot' +
              (index === activeIndex ? ' jm-slider-dot--active' : '')
            }
            onClick={() => {
              setActiveIndex(index);
              scheduleNextSlide();
            }}
          />
        ))}
      </div>
    </div>
  );
};
